module.exports = __webpack_public_path__ + "img/waves.d97f967.svg";